export default {
  path: '/article-list',
  meta: {
    title: '资讯',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/article-list`),
}



// WEBPACK FOOTER //
// ./src/views/ArticleList/router.js